import { Loading } from "orcs-design-system";

/** First list paint and first-open detail: fill the pane, not the 16px spinner. */
const InboxPaneLoading = () => (
  <Loading
    large
    primary
    centered
    height="100%"
    data-testid="inbox-pane-loading"
  />
);

export default InboxPaneLoading;
